import { getLocation } from "@faire/web--source/common/globals/getLocation";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
export var getGroupName = function(url, entry) {
    var location = getLocation();
    if (entry.requestStart === 0 && entry.responseStart === 0) {
        return "no-timing-info";
    } else if (isAppStaticCdn(url)) {
        if (url.pathname.startsWith("/static/js/") || url.pathname.startsWith("/_next/static/chunks/")) {
            return "faire-app-script";
        } else {
            return "faire-app-asset";
        }
    } else if (url.host === (location === null || location === void 0 ? void 0 : location.host) && url.pathname.startsWith("/api/")) {
        return "faire-api-request";
    } else {
        return "other";
    }
};
function isAppStaticCdn(url) {
    if (url.host === "cdn.faire.com" || url.host === "localhost:3000") {
        return url.pathname.startsWith("/static/") || url.pathname.startsWith("/_next/static/");
    }
    return false;
}
export var collectInfoByGroup = function(entries) {
    if (!entries) {
        return {};
    }
    var groups = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (entry == null || entry.name == null || entry.decodedBodySize == null || entry.encodedBodySize == null || entry.transferSize == null) {
                continue;
            }
            var url = new URL(entry.name);
            var groupName = getGroupName(url, entry);
            var group = groups.get(groupName);
            if (group == null) {
                group = {
                    encoded: 0,
                    decoded: 0,
                    transfer: 0,
                    count: 0
                };
                groups.set(groupName, group);
            }
            group.decoded += entry.decodedBodySize;
            group.encoded += entry.encodedBodySize;
            group.transfer += entry.transferSize;
            group.count += 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Object.fromEntries(groups.entries());
};
export var getInitialLoadResourceEntries = function() {
    var _getWindow_performance_getEntriesByType, _getWindow_performance, _getWindow;
    return (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_performance = _getWindow.performance) === null || _getWindow_performance === void 0 ? void 0 : (_getWindow_performance_getEntriesByType = _getWindow_performance.getEntriesByType) === null || _getWindow_performance_getEntriesByType === void 0 ? void 0 : _getWindow_performance_getEntriesByType.call(_getWindow_performance, "resource");
};
var roundToKb = function(value) {
    return Math.round(value / 1024);
};
var createArraySummary = function(summary) {
    if (summary) {
        return [
            roundToKb(summary.encoded),
            roundToKb(summary.decoded),
            roundToKb(summary.transfer),
            summary.count
        ];
    } else {
        return undefined;
    }
};
export var getPageWeightInfo = function(entries) {
    var groups = collectInfoByGroup(entries);
    return {
        appAsset: createArraySummary(groups["faire-app-asset"]),
        appScript: createArraySummary(groups["faire-app-script"]),
        apiRequest: createArraySummary(groups["faire-api-request"])
    };
};
